export const ProjectTypeRouting = [
  {
    path: "/project-config/project-type/list",
    name: "project-config-type-list",
    meta: { title: "项目类型定义" },
    component: () =>
      import(
        /* webpackCh`un`kName: "project-config-type" */ "@/views/project-config/project-type/list/index.vue"
      ),
  },
];
